"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.parse-float.js");

require("core-js/modules/es.array.concat.js");

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('div', {
    staticClass: "el-progress",
    "class": ['el-progress--' + _vm.type, _vm.status ? 'is-' + _vm.status : '', {
      'el-progress--without-text': !_vm.showText,
      'el-progress--text-inside': _vm.textInside
    }],
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.percentage,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_vm.type === 'line' ? _c('div', {
    staticClass: "el-progress-bar",
    attrs: {}
  }, [_c('div', {
    staticClass: "el-progress-bar__outer",
    style: {
      height: _vm._px2rem(_vm.strokeWidth + 'px', 24, [])
    },
    attrs: {}
  }, [_c('div', {
    staticClass: "el-progress-bar__inner",
    style: _vm._px2rem(_vm.barStyle, 24, []),
    attrs: {}
  }, [_vm.showText && _vm.textInside ? _c('div', {
    staticClass: "el-progress-bar__innerText",
    attrs: {}
  }, [_vm._v(_vm._s(_vm.percentage) + "%")]) : _vm._e()])])]) : _c('div', {
    staticClass: "el-progress-circle",
    style: {
      height: _vm._px2rem(_vm.width + 'px', 24, []),
      width: _vm._px2rem(_vm.width + 'px', 24, [])
    },
    attrs: {}
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 100 100"
    }
  }, [_c('path', {
    staticClass: "el-progress-circle__track",
    attrs: {
      "d": _vm.trackPath,
      "stroke": "#e5e9f2",
      "stroke-width": _vm.relativeStrokeWidth,
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "el-progress-circle__path",
    "class": {
      'is-default-color': !this.color
    },
    style: _vm._px2rem(_vm.circlePathStyle, 24, []),
    attrs: {
      "d": _vm.trackPath,
      "stroke-linecap": "round",
      "stroke": _vm.stroke,
      "stroke-width": _vm.relativeStrokeWidth,
      "fill": "none"
    }
  })])]), _vm._v(" "), _vm.showText && !_vm.textInside ? _c('div', {
    staticClass: "el-progress__text",
    style: {
      fontSize: _vm._px2rem(_vm.progressTextSize + 'px', 24, [])
    },
    attrs: {}
  }, [!_vm.status ? [_vm._v(_vm._s(_vm.percentage) + "%")] : _c('i', {
    "class": _vm.iconClass,
    attrs: {}
  })], 2) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElProgress',
  props: {
    type: {
      type: String,
      "default": 'line',
      validator: function validator(val) {
        return ['line', 'circle'].indexOf(val) > -1;
      }
    },
    percentage: {
      type: Number,
      "default": 0,
      required: true,
      validator: function validator(val) {
        return val >= 0 && val <= 100;
      }
    },
    status: {
      type: String
    },
    strokeWidth: {
      type: Number,
      "default": 6
    },
    textInside: {
      type: Boolean,
      "default": false
    },
    width: {
      type: Number,
      "default": 126
    },
    showText: {
      type: Boolean,
      "default": true
    },
    color: {
      type: String,
      "default": ''
    }
  },
  computed: {
    barStyle: function barStyle() {
      var style = {};
      style.width = this.percentage + '%';
      style.backgroundColor = this.color;
      return style;
    },
    relativeStrokeWidth: function relativeStrokeWidth() {
      return (this.strokeWidth / this.width * 100).toFixed(1);
    },
    trackPath: function trackPath() {
      var radius = parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
      return "M 50 50 m 0 -".concat(radius, " a ").concat(radius, " ").concat(radius, " 0 1 1 0 ").concat(radius * 2, " a ").concat(radius, " ").concat(radius, " 0 1 1 0 -").concat(radius * 2);
    },
    perimeter: function perimeter() {
      var radius = 50 - parseFloat(this.relativeStrokeWidth) / 2;
      return 2 * Math.PI * radius;
    },
    circlePathStyle: function circlePathStyle() {
      var perimeter = this.perimeter;
      return {
        strokeDasharray: "".concat(perimeter, "px,").concat(perimeter, "px"),
        strokeDashoffset: (1 - this.percentage / 100) * perimeter + 'px',
        transition: 'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease'
      };
    },
    stroke: function stroke() {
      var ret;

      if (this.color) {
        ret = this.color;
      } else {
        switch (this.status) {
          case 'success':
            ret = '#109C00';
            break;

          case 'exception':
            ret = '#FF364E';
            break;

          default:
            ret = '#00C0CB';
        }
      }

      return ret;
    },
    iconClass: function iconClass() {
      if (this.type === 'line') {
        return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-close';
      } else {
        return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
      }
    },
    progressTextSize: function progressTextSize() {
      return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
    }
  }
};
exports["default"] = _default;